import styled from 'styled-components';

import { Skeleton } from 'opencare-crown';

export const CircleImage = styled.div`
  & > img,
  svg {
    border: ${props => props.border};
    box-shadow: ${props => props.boxShadow};
    border-radius: 50%;
    height: ${props => props.height};
    max-height: ${props => props.height};
    width: ${props => props.width};
    max-width: ${props => props.width};
  }

  & > img:not(:last-child),
  svg:not(:last-child) {
    margin-right: ${props => props.marginRight || '-20px'};
  }
`;

export const AvatarSkeleton = styled(Skeleton)`
  .ant-skeleton-header {
    padding-right: 0;

    .ant-skeleton-avatar {
      height: ${props => props.height};
      width: ${props => props.width};
    }
  }
`;
